/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![FileDenyIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABrklEQVR4nN2UO0sDQRDHY2OjNhoRC2tfjZZio4UQw+7MRNjMnI9CP4J2VqIo+SwiCMZGRPBL+BEkCL5ilcrIZvf0PEnu8mo8WO522fn/ZvY/e5nMv3oQeQqILzTJB5DUmw2N/BzGABR3U4trlJdWwhAZ3wA3LyUCbOZpxeEvIBmSdCwQG8aYYRfHj6kg7YgDSR2RV3xcKebPUU8AmvjKxhljBi0kVsle1wBw2R4mmtsNAOxAKQMUV0NPeg+g1vekLwAg+ewNAKUCJKeImwtKBdm1te0hRcGSIl7vHoBSNsaM9sVk7Vp0wMYpDEgjX2viN438BMj3AAKdA1AqYeaAfNbC6JNOKzi1+xED7ec1IN63HqiNYAaIq+HeX16kBoAs+uzv3Brv27nWMqFJHvyag6DctP2zUyrIuoScCNHOWFTcvrWWee/VW6QCvkxXAYw0EkJ5d3MzFxOfyBkz7it5/QGAmbYLiR20UVz2Fd9GjyMU9/CDP0fkjOMpQDmPGgWxG4oY5L3J+Z91rhLxbKGwNenFaw1oQXKp70mTu3Ocuk07fWwruuOyVXPVfkfb8wtrmqpY3xkVTQAAAABJRU5ErkJggg==)
 */
export const FileDenyIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.27 12.38c.35.11.73-.13.73-.5V10.5a.5.5 0 0 0-.5-.5H19a5 5 0 0 1-5-5V2.5a.5.5 0 0 0-.5-.5H6a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h5.88c.37 0 .61-.38.5-.73a7 7 0 0 1 8.89-8.9Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.7 7.94c.01.03 0 .06-.04.06H19a3 3 0 0 1-3-3V2.34c0-.03.03-.05.06-.04a3 3 0 0 1 .82.58l4.24 4.24a3 3 0 0 1 .58.82Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M21.76 14.83a5.02 5.02 0 0 1 .78 7.7 5 5 0 0 1-7.07 0 5.02 5.02 0 0 1 0-7.07 5 5 0 0 1 6.29-.63Zm-4.88 2.05a3 3 0 0 1 3.41-.59l-4 4a3 3 0 0 1 .59-3.41Zm4.83.83-4 4a3 3 0 0 0 4-4Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
